import { useHandleAnalytics } from "../lib/analytics";
import { AnalyticEvents, AnalyticsBet } from "@fresh8/types/src/analytics";
import { usePixelMacros } from "../composition/pixelMacros";
import { BetSelection } from "@fresh8/types/src/betSelection";

export const useAnalytics = (
  props: {
    marketId?: string;
    eventId?: string;
    optionId?: string;
  },
  statsDesc: string
): {
  handleClick: (betSelections?: BetSelection[]) => void;
  handleViewed: (bets: AnalyticsBet[]) => void;
} => {
  const {
    getPixelUrl,
    getPixelMacroData,
    populatePixelUrl,
    getPixelType
  } = usePixelMacros();
  const $handleAnalytics = useHandleAnalytics();

  const handleClick = (betSelections?: BetSelection[]) => {
    const statsEvent = AnalyticEvents.CLICKED_THROUGH;
    let pixelData;
    let bets;
    const hasDynamicBetSelections = !!betSelections?.length;

    // Map selection and pixel data for Parlay click throughs
    if (!!betSelections && hasDynamicBetSelections) {
      pixelData = getPixelMacroData(betSelections[0]);
      bets = betSelections.map(selection => ({
        betOptionID: selection.optionId,
        betID: selection.marketId
      }));
    } else {
      pixelData = getPixelMacroData(props);
      bets =
        props.optionId && props.marketId
          ? [
              {
                betOptionID: props.optionId,
                betID: props.marketId
              }
            ]
          : [];
    }
    const pixelUrl = getPixelUrl(statsEvent);
    const pixelType = getPixelType();

    return $handleAnalytics(
      statsEvent,
      statsDesc,
      bets,
      // Only apply pixel data if pixelUrl exists.
      pixelUrl
        ? pixelData
          ? populatePixelUrl(pixelData, pixelUrl)
          : pixelUrl
        : undefined,
      pixelType
    );
  };

  const handleViewed = (bets: AnalyticsBet[]) => {
    const statsEvent = AnalyticEvents.VIEWED;
    const pixelType = getPixelType();
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(statsEvent, statsDesc, bets, pixelUrl, pixelType);
  };

  return { handleClick, handleViewed };
};

//TODO: make Pixels work with multiple selections
